import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import fieldTranslations from 'modules/payroll_integrations_datev_api/lib/fieldTranslations'

interface Props {
  unavailable_fields: string[] | null
  isLeaveIncidence: boolean
}

const MissingSalaryCode = ({ unavailable_fields, isLeaveIncidence }: Props) => {
  return (unavailable_fields ?? [])
    .filter((field) =>
      [
        'missing_salary_code',
        'missing_legal_entity_mapping',
        'missing_leave_type_mapping',
      ].includes(field)
    )
    .map((field: string) => (
      <Box
        background="radicalRed200"
        paddingX="s24"
        paddingY="s16"
        borderRadius={{
          all: 'abs008',
        }}
        gap="s16"
        key={field}
      >
        <Box gap="s4" flexDirection="row">
          <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />

          <Text.Header2 key={field}>{fieldTranslations.t(field)}</Text.Header2>
        </Box>
        <>
          {isLeaveIncidence
            ? i18n.t(
                'payroll_integrations.incidences.datev_lauds.absences.missing_leave_type_mapping.description'
              )
            : i18n.t(
                'payroll_integrations.incidences.datev_lauds.hiring.missing_salary_code.description'
              )}
        </>
      </Box>
    ))
}

export default MissingSalaryCode
